import { Dialog } from "@mui/material";
import React, { useEffect } from "react";
// import CircleExit from "../../assets/images/icon/add.svg"; //CircleExit
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";


export default function CookieSettingPopup(props) {
  const navigate = useNavigate();
  const [isConfirm, setIsConfirm] = React.useState(false);


  useEffect(() => {
    if (props["open"]) {
    }
    // eslint-disable-next-line
  }, [props["open"]]);

  const {
    onClose,
    open,
  } = props;

  const handleClose = () => {
    onClose(isConfirm);
  };


  return (
    <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth="xl">

      <div className="pb-[16px] pt-[25px] px-[17px] rounded-[4px] flex justify-between">
        <div>
          <p className="primary-color text-[34px] text-left leading-[33.6px]">
            ตั้งค่านโยบายความเป็น
          </p>
          <p className="primary-color text-[34px] text-left leading-[33.6px]">
            ส่วนตัวและคุกกี้
          </p>
        </div>
        {/* <div>
          <button onClick={handleClose}>
            <CircleExit />
          </button>
        </div> */}
      </div>
      <div className="text-[16px] px-[17px] max-h-[500px] overflow-y-auto">
        <div
          className="mt-[10px] mb-[10px] "
        >
          เมื่อท่านเข้าใช้บริการ www.haier.com/th (“เว็บไซต์”) นี้
          บริษัทจะเก็บรวบรวมและ/หรือใช้และในบางกรณีอาจเปิดเผยข้อมูลของท่าน
          ซึ่งอาจรวมถึงข้อมูลส่วนบุคคลของท่านด้วย
          โดยหลักเกณฑ์การเก็บรวบรวมและ/หรือใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคล
          เป็นไปตามข้อกำหนดที่กำหนดไว้ในนโยบายความเป็นส่วนตัวฉบับนี้
        </div>
        <div
          className="mb-[10px]"
        >
          โดยท่านสามารถเลือกที่จะยินยอมให้เราเก็บรวบรวมและ/หรือใช้และ/
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านหรือไม่ก็ได้
          ในกรณีที่ท่านไม่ให้ความยินยอมให้เรากระทำการดังกล่าวนั้นอาจ
          ส่งผลให้เราไม่สามารถให้บริการแก่ท่านได้อย่างเต็มประสิทธิภาพและตรงตามความต้องการ
          กรณีที่ข้อกำหนดและเงื่อนไขหรือข้อบังคับหรือประกาศใดที่ขัด
          ต่อนโยบายความเป็นส่วนตัวนี้ให้ยึดนโยบายความเป็นส่วนตัวนี้เป็นสำคัญ

        </div>

        <div className="font-bold primary-color">
          1. คำจำกัดความ
        </div>

        <div className="mb-[10px]">
          <p>1.1 ข้อมูลส่วนบุคคล หมายถึง ข้อมูลใด ๆ ที่สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าจะใช้ข้อมูลนั้นโดยลำพังหรือใช้ประกอบกับข้อมูลอื่นในการระบุตัวตน</p>
          <p>1.2 เว็บไซต์หมายถึง www.haier.com/th</p>
          <p>1.3 อุปกรณ์เคลื่อนที่ หมายถึง อุปกรณ์อิเล็กทรอนิกส์แบบพกพาใด ๆ ที่สามารถใช้งานเว็บไซต์นี้ได้ เช่น มือถือ แท็บแล็ต</p>
        </div>

        <div className="font-bold primary-color">
          2. ข้อมูลที่เราเก็บรวบรวมเราจะทำการเก็บรวบรวมข้อมูลของท่าน
          เมื่อท่านได้เข้าใช้บริการเว็บไซต์ของเราทำการติดต่อให้ข้อมูลหรือทำธุรกรรมใด ๆ
          กับเราไม่ว่าในช่องทางใด ซึ่งข้อมูลดังกล่าวอาจมีลักษณะเป็นข้อมูลส่วนบุคคล
          ทั้งนี้ข้อมูลที่เราเก็บรวบรวมหมายรวมถึงข้อมูลดังต่อไปนี้
        </div>

        <div className="mb-[10px]">
          <p>2.1 ข้อมูลที่จำเป็นสำหรับการสร้างบัญชี (Account) ได้แก่ ชื่อ นามสกุล เพศ ที่อยู่ เบอร์ติดต่อ หมายเลขบัตรประชาชน หมายเลขพาสปอร์ต และ email address</p>
          <p>2.2 ข้อมูลเกี่ยวกับการชำระเงินค่าสินค้าและบริการบนเว็บไซต์ ได้แก่ รายละเอียดบัญชีธนาคาร บัตร เครดิต/เดบิต และข้อมูลการชำระเงิน</p>
          <p>2.3 ข้อมูลการใช้งานเว็บไซต์ เช่น ช่วงเวลาและจำนวนครั้งที่ท่านเข้าชมเว็บไซต์ และคลิกดูสินค้าหรือใช้บริการใด ๆ บนเว็บไซต์และรวมถึงข้อมูลที่ได้จาก Cookies ด้วย</p>
          <p>2.4 ข้อมูลระบุตำแหน่ง (กรณีที่ท่านใช้บริการเว็บไซต์บนอุปกรณ์เคลื่อนที่) เช่น ข้อมูล GPS ที่อุปกรณ์ เคลื่อนที่ของท่านให้บริการ ทั้งนี้ บริการข้อมูลระบุตำแหน่งนี้เป็นบริการของอุปกรณ์เคลื่อนที่โปรดตรวจสอบข้อกำหนดและเงื่อนไขและนโยบายความเป็นส่วนตัวของผู้ผลิตอุปกรณ์เคลื่อนที่ หรือ ผู้ให้บริการอุปกรณ์เคลื่อนที่เพื่อศึกษาข้อมูลเพิ่มเติม</p>
          <p>2.5 ข้อมูลอื่น ๆ ที่ท่านได้ให้แก่เรา เช่น ข้อมูลที่ได้จากการที่ท่านใช้งานเว็บไซต์ข้อมูลที่ท่านได้กรอกลงบน เว็บไซต์หรือเอกสารต่าง ๆ ข้อมูลที่ท่านร่วมกิจกรรมกับเรา ข้อมูลที่ท่านให้เมื่อติดต่อเรา</p>
        </div>

        <div className="font-bold primary-color">
          3. การใช้ข้อมูลส่วนบุคคลเราจะใช้ข้อมูลส่วนบุคคลของท่านในการให้บริการเว็บไซต์นี้ รวมถึงนำไปใช้ตามวัตถุประสงค์ที่ระบุไว้ในนโยบายฉบับนี้หรือตามวัตถุประสงค์อื่น ๆ
          ที่แจ้งขณะเก็บรวบรวมข้อมูลหรือที่ท่านได้ให้ความยินยอมหลังจาก
          เราเก็บข้อมูลไปแล้ว ทั้งนี้ ข้อมูลส่วนบุคคลของท่านอาจนำไปใช้เพื่อวัตถุประสงค์ดังต่อไปนี้
        </div>

        <div className="mb-[10px]">
          <p>3.1 สร้างและจัดการบัญชี (Account) ของท่าน และติดต่อท่านเกี่ยวกับบัญชีของท่าน</p>
          <p>3.2 ดำเนินการเกี่ยวกับธุรกรรมใด ๆ ที่เกี่ยวข้องกับเว็บไซต์ซึ่งรวมถึงการชำระเงินค่าสินค้าและบริการด้วย</p>
          <p>3.3 ยืนยันตัวตนของท่าน หรือตรวจสอบความถูกต้อง เพื่อรักษาความปลอดภัยในการใช้ข้อมูลส่วนบุคคล</p>
          <p>3.4 ให้ข้อมูลจัดทำและติดต่อท่านเกี่ยวกับสินค้าสินค้าบริการกิจกรรมการสำรวจความคิดเห็นและโปรโมชั่นต่าง ๆ ของเรา</p>
          <p>3.5 ประมวลผล วัดผล และตอบสนองเพื่อให้บริการ รวมถึงตอบคำถาม และคำขอของท่าน</p>
          <p>3.6 ดำเนินกิจการ ประเมินผล และปรับปรุงธุรกิจ พัฒนาสินค้า เว็บไซต์หรือบริการใหม่จัดการระบบ การสื่อสาร สำรวจตลาดวัดผลและบริหารประสิทธิภาพในการทำโฆษณาและการตลาด วิเคราะห์ สินค้า บริการ และเว็บไซต์ของเรา รวมทั้งบริหารจัดการเว็บไซต์ของเรา</p>
          <p>3.7 กรณีที่ท่านให้ความยินยอมเราจะส่งข้อมูลการตลาดและการส่งเสริมการขายและเอกสารที่เกี่ยวข้องกับสินค้าและ/หรือ บริการที่อยู่บนเว็บไซต์ไม่ว่าจะมีอยู่ในขณะนี้หรือจะเกิดขึ้นในอนาคตให้แก่ท่านผ่านรูปแบบการติดต่อสื่อสารต่าง ๆ เช่น SMS อีเมล ไปรษณีย์เพื่อประโยชน์ในทางการตลาดของเรา</p>
          <p>3.8 บริหารจัดการความเสี่ยงและพัฒนาคุณภาพ</p>
          <p>3.9 รักษาความปลอดภัยในการให้บริการผ่านทางเครือข่ายของเราคุ้มครองแหล่งข้อมูลและพนักงาน</p>
          <p>3.10 สอบสวนและปฎิบัติตามกฎหมาย ข้อบังคับ มาตรฐานทางอุตสาหกรรม ตลอดจนบังคับใช้นโยบาย และข้อกำหนดอื่น ๆ ของเรา</p>
        </div>

        <div className="font-bold primary-color">
          4.การเปิดเผยข้อมูลส่วนบุคคล เราอาจเปิดเผยข้อมูลส่วนบุคคลในกรณีดังต่อไปนี้
        </div>

        <div className="mb-[10px]">
          <p>4.1 เพื่อประโยชน์ในการพัฒนาการให้บริการแก่ท่านหรือการประกอบธุรกิจของเรา เราอาจเปิดเผย และ/หรือ ส่งต่อข้อมูลส่วนบุคคลกับ</p>
          <p>4.1.1 ผู้รับจ้างของบริษัทที่ให้บริการสร้างบำรุงรักษาและปรับปรุงระบบและเว็บไซต์</p>
          <p>4.1.2 บริษัทหรือบุคคลอื่นที่ให้บริการแก่ท่าน เช่น การให้บริการชำระเงินผ่านบัตรเครดิต หรือช่องทางการชำระเงินอื่น การบริการขนส่ง ทั้งนี้ เฉพาะในส่วนที่จำเป็นต่อการให้บริการแก่ท่านเท่านั้น</p>
          <p>4.1.3 ผู้ขาย และ/หรือ ผู้ให้บริการ ที่ขายสินค้าและ/หรือ ให้บริการบนเว็บไซต์</p>
          <p>4.2 เราขอสงวนสิทธิในการโอนข้อมูลส่วนบุคคลหากมีการปรับโครงสร้างจำหน่าย หรือโอนย้ายกิจการหรือสินทรัพย์ของเรา ซึ่งกรณีดังกล่าวอาจมีการเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับผู้ซื้อกิจการ และ/หรือ ที่ปรึกษาของผู้ซื้อกิจการ อย่างไรก็ดี เราจะรักษาข้อมูลส่วนบุคคลของท่านอย่างเต็มความสามารถ รวมถึงกำหนดให้ผู้ซื้อกิจการ และ/หรือ ที่ปรึกษาของผู้ซื้อกิจการปฏิบัติตามหลักเกณฑ์การคุ้มครอง ข้อมูลส่วนบุคคลของเราด้วย</p>
          <p>4.3 นอกจากกรณีข้างต้น ท่านเข้าใจและยอมรับว่า เราอาจเปิดเผย หรือส่งต่อข้อมูลส่วนบุคคลของท่านใน กรณีดังต่อไปนี้</p>
          <p>4.3.1 กรณีที่กฎหมายหรือกระบวนการทางกฎหมายกำหนดให้ต้องกระทำ เช่น เปิดเผยต่อเจ้าพนักงานเจ้าหน้าที่รัฐหรือหน่วยงานที่มีอานาจเพื่อปฎิบัติตามคำสั่งหรือคำขอที่ชอบด้วยกฎหมาย</p>
          <p>4.3.2 เพื่อการสอบสวนการกระทำอันอาจผิดกฎหมายโดยที่เราไม่สามารถขอความยินยอมจากท่านได้</p>
          <p>4.3.3 เปิดเผยข้อมูลส่วนบุคคลที่ผ่านกระบวนการซึ่งทำให้ไม่สามารถระบุตัวตนได้ต่อสาธารณชนเพื่อประโยชน์ในการประกอบธุรกิจของเราและ</p>
          <p>4.3.4 กรณีอื่น ๆ ที่กฎหมายกำหนดให้กระทำได้โดยไม่ต้องได้รับความยินยอมจากท่าน เช่น กรณี จำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของเรา กรณีจำเป็นเพื่อการดำเนินภารกิจเพื่อประโชน์สาธารณะ</p>
        </div>

        <div className="font-bold primary-color">
          5. การถ่ายโอนข้อมูลส่วนบุคคลไปต่างประเทศ
        </div>

        <div className="mb-[10px]">
          <p>5.1 เพื่อวัตถุประสงค์ในการให้บริการตามที่กำหนดในนโยบายความเป็นส่วนตัวนี้เราอาจจัดเก็บประมวลผลหรือเปิดเผยข้อมูลส่วนบุคคลของท่านต่อบริษัทในเครือ ผู้รับจ้าง หรือผู้ให้บริการของเราที่ตั้งอยู่นอกประเทศ โดยเราจะกระทำเท่าที่จำเป็นต่อการให้บริการแก่ท่านเท่านั้น </p>
          <p>5.2 เซิร์ฟเวอร์และฐานข้อมูลกลางของเราตั้งอยู่ที่ประเทศอินเดีย การจัดเก็บ การประมวลผล และการ ดำเนินการใด ๆ เกี่ยวกับข้อมูลส่วนบุคคลโดยส่วนใหญ่จึงเกิดขึ้นที่ประเทศอินเดีย ซึ่งท่านเข้าใจและยอมรับว่ามาตรฐานการคุ้มครองข้อมูลส่วนบุคคลในประเทศอินเดียนั้นอาจไม่เพียงพอตามที่กฎหมายกำหนดและท่านยินยอมให้เราจัดเก็บ ประมวลผล และเปิดเผยข้อมูลส่วนบุคคลของท่านไปยังประเทศอินเดีย อย่างไรก็ดี เราจะกระทำเท่าที่จำเป็นต่อการให้บริการแก่ท่านเท่านั้น</p>
        </div>

        <div className="font-bold primary-color">
          6. การใช้ Cookies เพื่อให้เราสามารถให้บริการเว็บไซต์แก่ท่านได้อย่างมีประสิทธิภาพ เราจำเป็นต้องติดตั้ง Cookies ลงบน คอมพิวเตอร์ หรืออุปกรณ์อิเล็กทรอนิกส์ของท่าน โดยท่านสามารถศึกษาข้อมูลเกี่ยวกับประเภท ลักษณะ และวิธีการที่เราใช้ Cookies บนเว็บไซต์นี้เพิ่มเติมได้ที่หัวข้อ Cookies notice
        </div>

        <div className="font-bold primary-color">
          7. การปกป้องข้อมูลส่วนบุคคล เราได้จัดให้มีมาตรการรักษาความปลอดภัยข้อมูลส่วนบุคคลที่เราได้รับจากท่าน เพื่อมิให้มีการเปิดเผยใช้งานเปลี่ยนแปลงหรือทำลายข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับอนุญาต โดยเราได้จัดให้มีระบบรักษาความปลอดภัยที่ได้มาตรฐาน ทั้งการประมวลผลข้อมูล การเก็บข้อมูล และการโอนถ่ายข้อมูล และจำกัดพนักงานของ เราที่สามารถเข้าถึงข้อมูลส่วนบุคคลได้
        </div>

        <div className="font-bold primary-color">
          8. การจัดการให้ข้อมูลส่วนบุคคลมีความถูกต้องและเป็นปัจจุบัน
        </div>

        <div className="mb-[10px]">
          <p>8.1 เราจะใช้ความพยายามในการอัปเดตข้อมูลส่วนบุคคลของท่านให้มีความถูกต้อง และเป็นปัจจุบันที่สุดเท่าที่เราจะสามารถทำได้</p>
          <p>8.2 เราแนะนำให้ท่านตรวจสอบข้อมูลส่วนบุคคลของท่านที่เราจัดให้ท่านสามารถเข้าถึงและแก้ไขได้เองเป็นครั้งคราวเพื่อส่งเสริมให้ข้อมูลมีความถูกต้องและเป็นปัจจุบัน </p>
        </div>

        <div className="font-bold primary-color">
          9. ระยะเวลาการเก็บข้อมูลส่วนบุคคล เราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้นานเท่าที่จำเป็นเพื่อทำตามวัตถุประสงค์นั้น ๆ ทั้งนี้
        </div>

        <div className="mb-[10px]">
          <p>9.1 เราจะเก็บข้อมูลการการสร้างบัญชีของท่านเท่าที่บัญชีของท่านยังคงอยู่ เพื่อให้เราสามารถให้บริการแก่ท่านได้นอกจากนี้หากบัญชีของท่านไม่มีการเข้าใช้งานใด ๆ เป็นระยะเวลาติดต่อกัน 10 ปี เราจะทำการลบบัญชีของท่าน </p>
          <p>9.2 เราจะเก็บข้อมูลเกี่ยวกับการชำระเงินค่าสินค้าและบริการบนเว็บไซต์เป็นเวลา 10 หรือจนกว่าเราจะลบข้อมูลส่วนบุคคลของท่านตามคำขอของท่าน หรือท่านทำการลบบัญชีของท่าน </p>
          <p>9.3 เราจะเก็บข้อมูลการใช้งานเว็บไซต์ของท่านไว้นานเท่าที่จำเป็นสำหรับการดำเนินธุรกิจและการรักษาความปลอดภัย ตามที่เราได้แจ้งไว้ในนโยบายความเป็นส่วนตัวนี้ </p>
          <p>9.4 เราจะเก็บข้อมูลระบุตำแหน่ง เป็นระยะเวลา 10 หรือจนกว่าเราจะลบข้อมูลส่วนบุคคลของท่านตามคำขอของท่าน หรือท่านทำการลบบัญชีของท่าน ทั้งนี้ เราอาจเก็บข้อมูลส่วนบุคคลของท่านไว้เป็นระยะเวลาน้อยกว่าหรือนานกว่าที่กำหนดข้างต้น หากเป็นกรณีที่กฎหมายกำหนด หรือกรณีจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของเรา </p>
        </div>

        <div className="font-bold primary-color">
          10. สิทธิเกี่ยวกับข้อมูลของท่าน
        </div>

        <div className="mb-[10px]">
          <p>10.1 ท่านสามารถจัดการข้อมูลส่วนบุคคลของท่านได้ดังนี้</p>
          <p>10.1.1 ข้อมูลสำหรับการสร้างบัญชี: </p>
          <p>- ท่านสามารถเข้าถึง และแก้ไขข้อมูลส่วนบุคคลของท่านได้ โดยคลิกที่บัญชีของท่านบนแถบเมนูแล้วเลือกจัดการบัญชี</p>
          <p>- ท่านสามารถลบข้อมูลส่วนบุคคลของท่านได้ โดยการลบบัญชีของท่าน ทั้งนี้ ท่านจะไม่สามารถเข้าใช้เว็บไซต์ในส่วนที่ต้องใช้บัญชีได้ เช่น การซื้อขายสินค้าและบริการ </p>
          <p>- กรณีที่ท่านต้องการคัดลอกหรือโอนข้อมูลส่วนบุคคลโปรดติดต่อเราทางอีเมล หรือ Call Center โดยเราจะดำเนินการให้ท่านโดยเร็วที่สุดที่จะสามารถกระทำได้ภายหลังจากที่เราตรวจสอบสิทธิของท่านเรียบร้อยแล้ว</p>
          <p>10.1.2 ข้อมูลระบุตำแหน่ง ท่านสามารถยกเลิกความยินยอมให้เราใช้ข้อมูลระบุตำแหน่งได้โดยการตั้งค่าบนอุปกรณ์เคลื่อนที่เพื่อปิดการใช้งานบริการข้อมูลระบุตำแหน่งของคุณหากท่านมีข้อสงสัยเกี่ยวกับวิธีการปิดการใช้งานบริการดังกล่าวโปรดติดต่อผู้ให้บริการอุปกรณ์เคลื่อนที่ของท่าน ทั้งนี้ หากท่านต้องการเข้าถึง แก้ไข ลบ คัดลอก หรือโอนย้ายข้อมูลระบุตำแหน่งที่เราเก็บ รวบรวม โปรดติดต่อเราทางอีเมล หรือติดต่อ Call Center</p>
          <p>10.1.3 ข้อมูลส่วนบุคคลอื่น ๆ หากท่านต้องการเข้าถึง แก้ไข ลบ คัดลอก หรือโอนย้ายข้อมูลส่วนบุคคล โปรดติดต่อเราทางอีเมล หรือติดต่อ Call Center โดยเราจะดำเนินการให้ท่านโดยเร็วที่สุดที่จะ สามารถกระทำได้ภายหลังจากที่เราตรวจสอบความถูกต้องเรียบร้อยแล้ว ทั้งนี้ หากท่านเลือกลบข้อมูลส่วนบุคคลของท่าน ท่านจะไม่สามารถเข้าถึงข้อมูลส่วนบุคคล ได้อีก</p>
          <p>10.2 ท่านสามารถทำการ Unsubscribe การแจ้งเตือน หรือข้อความใด ๆ ที่เกี่ยวกับการให้บริการหรือ การตลาดของเรา รวมถึงขอให้เราลบหรือหยุดทำการประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อทำการตลาดของเราได้ โดยทำการ Unsubscribe ที่ด้านล่างของอีเมลการตลาดที่ท่านได้รับ อย่างไรก็ดี การแจ้งเตือนหรือข้อความฉุกเฉินจะยังคงส่งถึงท่านอยู่</p>
          <p>10.3 สิทธิของท่านตามที่กล่าวมาข้างต้นอาจถูกจำกัดในบางกรณี เช่น เราจำเป็นต้องใช้ข้อมูลส่วนบุคคลของท่านในการให้บริการเว็บไซต์แก่ท่าน กรณีที่กฎหมายกำหนดให้เราต้องเก็บรวบรวม ใช้ หรือ เปิดเผยข้อมูลส่วนบุคคล กรณีจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของเรา</p>
          <p>10.4 หากท่านมีข้อสงสัยหรือข้อเสนอแนะใด ๆ โปรดติดต่อ Call Center</p>
        </div>

        <div className="font-bold primary-color">
          11. การปรับปรุงแก้ไข หรือเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
        </div>

        <div className="mb-[10px]">
          <p>11.1 ท่านเข้าใจและยอมรับว่า เรามีสิทธิที่จะปรับปรุงแก้ไข หรือเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้โดยไม่ต้องแจ้งล่วงหน้า โดยเราจะประกาศข้อกำหนดและเงื่อนไขที่ปรับปรุงแก้ไขหรือเปลี่ยนแปลงบนเว็บไซต์ให้ท่านได้พิจารณาก่อนการเข้าใช้งานเว็บไซต์พร้อมระบุวันที่แก้ไขเพิ่มเติมครั้งล่าสุด การที่ท่านใช้บริการทางเว็บไซต์ของเราต่อไปหลังจากที่มีการปรับปรุงแก้ไข หรือเปลี่ยนแปลงนโยบายความเป็นส่วนตัวแล้วจะถือว่าท่านยอมรับนโยบายความเป็นส่วนตัวที่ปรับปรุงแก้ไข หรือเปลี่ยนแปลงนั้น แล้วโดยชัดแจ้ง </p>
          <p>11.2 ท่านสามารถเรียกดูนโยบายความเป็นส่วนตัวฉบับปัจจุบัน ได้โดยเลือกเมนู Setting และเลือกหัวข้อ “นโยบายความเป็นส่วนตัว” ทั้งนี้ หากท่านต้องการดูนโยบายความเป็นส่วนตัวฉบับก่อนหน้า โปรดติดต่อ Call Center </p>
        </div>

        <div className="font-bold primary-color">
          12. ผู้ควบคุมข้อมูลส่วนบุคคล
        </div>

        <div className="mb-[10px]">
          <p>12.1 ผู้ควบคุมข้อมูลส่วนบุคคลคือ ผู้ที่มีอานาจในการตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผย ข้อมูลส่วนบุคคลของท่าน</p>
          <p>12.2 การให้บริการเว็บไซต์นี้ เรา บริษัท ไฮเออร์ อีเลคทริคอล แอพพลายแอนซ์ (ประเทศไทย) จำกัด เป็นผู้ควบคุมข้อมูลส่วนบุคคลของ ท่าน โดยท่านสามารถติดต่อเราได้ที่ </p>
          <p>ที่อยู่ : 90 อาคารซีดับเบิ้ลยู ทาวเวอร์ (ตึก เอ) ชั้นที่ 42-43 ถนนรัชดาภิเษก แขวงห้วยขวาง เขตห้วยขวาง กรุงเทพมหานคร 10310</p>
          {/* <p>เมล : support@haier.com/th </p> */}
          <p>Call Center : 1789 (วัน-เวลาทำการ วันจันทร์-วันอาทิตย์ 8.30-17.30 น.)</p>
          <p>LINE OA: @‌haierthailand</p>
        </div>

      </div>
      <div style={{ marginTop: 52 }}>
        <Box>
          <Paper
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1,
            }}
            elevation={1}
          >
            <BottomNavigation
              className="px-[10%]"
              style={{ gap: "12px", alignItems: "center", height: "52px" }}
            >
              {/* <button
                onClick={handleClose}
                className="flex justify-center items-center border-[1px] border-blue rounded-[28px] w-full gap-[10px] py-[4px]"
              >
                <p className="text-[16px] text-blue text-center">
                  ไม่ยินยอม
                </p>
              </button> */}
              <button
                onClick={() => {
                  setIsConfirm(true)
                  handleClose()
                }}
                className="flex justify-center items-center bg-blue rounded-[28px] w-[60%] gap-[10px] py-[4px]"
              >
                <p className="text-[16px] text-white text-center">
                  ปิด
                </p>
              </button>
            </BottomNavigation>
          </Paper>
        </Box>
      </div>
    </Dialog>
  );
}
